import { cn } from '../lib/cn';

/** Pill toggle (skill §6b): selected = solid blue, normal = muted gray. */
export function SegmentedControl<T extends string>({
  value,
  options,
  onChange,
}: {
  value: T;
  options: Array<{ value: T; label: string; count?: number }>;
  onChange: (value: T) => void;
}) {
  return (
    <div className="inline-flex items-center gap-1">
      {options.map((opt) => {
        const active = opt.value === value;
        return (
          <button
            key={opt.value}
            onClick={() => onChange(opt.value)}
            className={cn(
              'whitespace-nowrap rounded-full px-3 py-1 text-xs font-medium transition-colors',
              active ? 'bg-blue-600 text-white' : 'text-gray-500 hover:bg-gray-100 hover:text-gray-700',
            )}
          >
            {opt.label}
            {opt.count !== undefined && opt.count > 0 && (
              <span className={cn('ml-1', active ? 'text-blue-100' : 'text-gray-400')}>
                {opt.count}
              </span>
            )}
          </button>
        );
      })}
    </div>
  );
}
